import React, {useEffect, useState} from 'react';
import {Link, useOutletContext, useParams, useSearchParams} from 'react-router-dom';
import TitleMain from "../../../components/Title/TitleMain";
import {useModal} from "../../../contexts/ModalContext";
import {useUser} from "../../../contexts/UserContext";
import AxiosConfig from "../../../services/AxiosConfig";
import {useBreadcrumb} from "../../../contexts/BreadcrumbContext";
import {generateBreadcrumbSegmentsAdmin} from "../../../services/BreadcrumbService";
import ParticipantCreation from "../../../components/Admin/Participants/ParticipantCreation";
import ParticipationsVue from "../../../components/Admin/Participants/ParticipationsVue";
import {setPresenceParticipant} from "../../../services/UserService";

function AdminParticipationsPage() {
    const {user} = useUser();
    const {showModal, hideModal} = useModal();
    const [myApiData, setMyApiData] = useState([]);
    const {entrepriseId, contratId, activiteId, seanceId} = useParams();
    const { updateDynamicBreadcrumb } = useBreadcrumb();
    const [entreprise, setEntreprise] = useState({});
    const [contrat, setContrat] = useState({});
    const [activite, setActivite] = useState({});
    const [seance, setSeance] = useState({});
    const [searchParams] = useSearchParams();
    const mode = searchParams.get('mode') || 'consultation';

    const handleSuccess = (children = "Note enregistrée avec succès") => {
        showModal('success', {children: children, timeout: 1500});
    };
    const handleError = (children = "Une erreur est survenue") => {
        showModal('error', {children: children, timeout: 1500});
    };

    const getParticipation = async () => {
        try {
            const response = await AxiosConfig.get(`/admin/entreprises/${entrepriseId}/contrats/${contratId}/activites/${activiteId}/seances/${seanceId}/participations`);

            const parseData = response.data.myParticipants;
            setMyApiData(parseData);
            setContrat(response.data.myContrat);
            setEntreprise(response.data.myEntreprise);
            setActivite(response.data.myActivite);
            setSeance(response.data.mySeance);
        } catch (error) {
            console.error('error', error);
        }
    }

    const putActifOpenModal = (row) => {
        const text = row.actif ? "supprimer" : "activer";
        showModal('confirm', {
            message: `Voulez-vous vraiment ${text} cette participation ?`,
            onConfirm: async () => {
                try {
                    const response = await AxiosConfig.post(`/admin/entreprises/${entreprise.id}/contrats/${contrat.id}/activites/${activite.id}/seances/${seance.id}/participations/${row.id}/actif`, {actif: !row.actif});
                    if (response.data.success) {
                        setTimeout(async () => {
                            getParticipation();
                        }, 500);
                    }
                    handleSuccess("Modifié avec succès");
                } catch (error) {
                    console.error('error', error);
                    handleError();
                }
            }
        });
    }

    const putShowModalRatingOpenModal = (row) => {
        const text = row.show_modal_rating ? "désactiver" : "activer";

        showModal('confirm', {
            message: `Voulez-vous vraiment ${text} la popup d'évaluation de cette participation ?`,
            onConfirm: async () => {
                try {
                    const response = await AxiosConfig.post(`/admin/entreprises/${entreprise.id}/contrats/${contrat.id}/activites/${activite.id}/seances/${seance.id}/participations/${row.id}/show_modal_rating`, {show_modal_rating: !row.show_modal_rating});
                    if (response.data.success) {
                        setTimeout(async () => {
                            getParticipation();
                        }, 500);
                    }
                    handleSuccess("Modifié avec succès");
                } catch (error) {
                    console.error('error', error);
                    handleError();
                }
            }
        });
    }

    const putParticipationPresenceOpenModal = (participantId, seanceId, value) => {
        const text = value ? "l'absence" : "la présence";
        showModal('confirm', {
            message: `Confirmer ${text} cet utilisateur pour cette séance ?`,
            onConfirm: async () => {
                try {
                    const data = await setPresenceParticipant(seanceId, participantId, !value);
                    if (data.success) {
                        setTimeout(async () => {
                            getParticipation();
                        }, 500);
                        handleSuccess("Participation mise à jour avec succès");
                    } else {
                        handleError(data.msg);
                    }
                } catch (error) {
                    console.error('error', error);
                    handleError();
                }
            }
        });
    }

    const handleSubmitParticipationStatus = async (values, {setSubmitting}) => {
        try {
            const response = await AxiosConfig.post(`/admin/participations/${values.id}/status`, values);

            if (response.data.success) {
                handleSuccess(response.data.message);
                getParticipation();
            } else {
                console.error('error', response.data);
                handleError("Erreur : " + response.data.message);
            }
        } catch (error) {
            console.error('error', error);
            handleError();
        }
    };

    useEffect(() => {
        getParticipation();
    }, [user, mode]);

    useEffect(() => {
        updateDynamicBreadcrumb(generateBreadcrumbSegmentsAdmin({ entreprise, contrat, activite, seance}));
    }, [ entreprise, contrat, activite, seance ]);


    const list = myApiData.map((asu, index) => {
        return (
            <li key={index}>
                <Link to={`${asu.id.toString()}`}>consulter la participation </Link>
            </li>
        )
    });

    return (
        <div className="content_tab">
            <TitleMain text="Participations"/>

            {mode === 'creation' ?
                <ParticipantCreation entreprise={entreprise} contrat={contrat} activite={activite} seance={seance} />
                :
                <ParticipationsVue entreprise={entreprise}
                                   contrat={contrat}
                                   activite={activite}
                                   seance={seance}
                                   participations={myApiData}
                                   putActifOpenModal={putActifOpenModal}
                                   putShowModalRatingOpenModal={putShowModalRatingOpenModal}
                                   handleSubmitParticipationStatus={handleSubmitParticipationStatus}
                                      putParticipationPresenceOpenModal={putParticipationPresenceOpenModal}
                />
            }
        </div>
    )
}

export default AdminParticipationsPage;
